import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de Screenfeed -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// El PDF OFICIAL de Screenfeed trae en la capa de texto pdfjs SOLO el monto ("charged in the amount
// of $160.00") y la fecha de FIN de suscripcion ("through <Month> <DD>, <YYYY>"). El ORDER DATE,
// QUANTITY y ORDER TOTAL estan como IMAGEN, no como texto. Obligatorios (throw, todo-o-nada): folio,
// monto, fecha. unidades y concepto van null (el concepto lo arma el hook con el molde "Screenfeed AAAA/MM").
export const parsearScreenfeedDesdeTexto = (texto, nombreArchivo) => {
  // pdfjs mete espacios multiples -> normalizar a un solo espacio antes de anclar.
  const t = texto.replace(/\s+/g, " ");

  // folio: del NOMBRE DEL ARCHIVO (no esta en el cuerpo) -> ultimo segmento numerico. Obligatorio.
  const nums = (nombreArchivo || "").match(/\d+/g);
  if (!nums) throw new Error("No se pudo leer el folio de Screenfeed (falta segmento numerico en el nombre)");
  const folio = nums.at(-1);

  // monto: de la frase "charged in the amount of $160.00". Obligatorio.
  const mMonto = t.match(/amount of\s*\$?\s*([\d,]+\.\d{2})/i);
  if (!mMonto) throw new Error("No se pudo leer el monto de la factura Screenfeed");
  const monto = Number(mMonto[1].replace(/,/g, ""));

  // fecha: de "through <Month> <DD>, <YYYY>" (fin de suscripcion, ej. "through July 24, 2026").
  // La factura es del MES ANTERIOR -> fecha = dia 1 del mes anterior al del "through". Obligatorio.
  const mThrough = t.match(/through\s+([a-z]+\s+\d{1,2},\s*\d{4})/i);
  const fechaThrough = mThrough ? parseFecha(mThrough[1]) : null; // "YYYY-MM-DD"
  if (!fechaThrough) throw new Error("No se pudo leer la fecha 'through' de la factura Screenfeed");
  // Derivacion con aritmetica de numeros (NUNCA new Date -> evita corrimientos por TZ).
  // Borde ENERO: si el "through" cae en enero (mes 1) el mes anterior es DICIEMBRE del anio anterior
  // (mes 1 -> 12, anio - 1). Ej: "January .., 2026" -> "2025-12-01".
  const [anioTh, mesTh] = fechaThrough.split("-").map(Number);
  const mesAnt = mesTh === 1 ? 12 : mesTh - 1;
  const anioAnt = mesTh === 1 ? anioTh - 1 : anioTh;
  const fecha = `${anioAnt}-${String(mesAnt).padStart(2, "0")}-01`;

  // periodo: dia 1 del mes de la fecha (fecha ya es dia 1). unidades/concepto: null.
  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto: null, monto, moneda: "USD", unidades: null };
};
